export const map = () => (
    <svg
        width="16"
        height="15"
        viewBox="0 0 16 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M11.2812 4.03125C11.2812 5.53516 9.25781 8.1875 8.38281 9.28125C8.19141 9.55469 7.78125 9.55469 7.58984 9.28125C6.71484 8.1875 4.71875 5.53516 4.71875 4.03125C4.71875 2.22656 6.16797 0.75 8 0.75C9.80469 0.75 11.2812 2.22656 11.2812 4.03125ZM11.5 6.24609C11.582 6.05469 11.6641 5.86328 11.7461 5.67188C11.7734 5.64453 11.7734 5.61719 11.8008 5.58984L14.9727 4.30469C15.3828 4.14062 15.875 4.44141 15.875 4.90625V12.3164C15.875 12.5898 15.7109 12.8359 15.4375 12.9453L11.5 14.5039V6.24609ZM3.87109 4.55078C3.95312 4.93359 4.0625 5.31641 4.22656 5.67188C4.30859 5.86328 4.39062 6.05469 4.5 6.24609V13.1094L1 14.5039C0.589844 14.668 0.125 14.3672 0.125 13.9023V6.49219C0.125 6.21875 0.289062 5.97266 0.535156 5.89062L3.87109 4.55078ZM9.06641 9.82812C9.44922 9.36328 10.0508 8.59766 10.625 7.72266V14.5586L5.375 13.0547V7.72266C5.92188 8.59766 6.52344 9.36328 6.90625 9.82812C7.45312 10.5391 8.51953 10.5391 9.06641 9.82812ZM8 4.90625C8.38281 4.90625 8.73828 4.71484 8.92969 4.35938C9.12109 4.03125 9.12109 3.62109 8.92969 3.26562C8.73828 2.9375 8.38281 2.71875 8 2.71875C7.58984 2.71875 7.23438 2.9375 7.04297 3.26562C6.85156 3.62109 6.85156 4.03125 7.04297 4.35938C7.23438 4.71484 7.58984 4.90625 8 4.90625Z"
            fill="#006589"
        />
    </svg>
);

export const list = () => (
    <svg
        width="15"
        height="12"
        viewBox="0 0 15 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M1.59375 0.0625H2.90625C3.26172 0.0625 3.5625 0.363281 3.5625 0.71875V2.03125C3.5625 2.41406 3.26172 2.6875 2.90625 2.6875H1.59375C1.21094 2.6875 0.9375 2.41406 0.9375 2.03125V0.71875C0.9375 0.363281 1.21094 0.0625 1.59375 0.0625ZM5.75 0.5H13.625C14.0898 0.5 14.5 0.910156 14.5 1.375C14.5 1.86719 14.0898 2.25 13.625 2.25H5.75C5.25781 2.25 4.875 1.86719 4.875 1.375C4.875 0.910156 5.25781 0.5 5.75 0.5ZM5.75 4.875H13.625C14.0898 4.875 14.5 5.28516 14.5 5.75C14.5 6.24219 14.0898 6.625 13.625 6.625H5.75C5.25781 6.625 4.875 6.24219 4.875 5.75C4.875 5.28516 5.25781 4.875 5.75 4.875ZM5.75 9.25H13.625C14.0898 9.25 14.5 9.66016 14.5 10.125C14.5 10.6172 14.0898 11 13.625 11H5.75C5.25781 11 4.875 10.6172 4.875 10.125C4.875 9.66016 5.25781 9.25 5.75 9.25ZM0.9375 5.09375C0.9375 4.73828 1.21094 4.4375 1.59375 4.4375H2.90625C3.26172 4.4375 3.5625 4.73828 3.5625 5.09375V6.40625C3.5625 6.78906 3.26172 7.0625 2.90625 7.0625H1.59375C1.21094 7.0625 0.9375 6.78906 0.9375 6.40625V5.09375ZM1.59375 8.8125H2.90625C3.26172 8.8125 3.5625 9.11328 3.5625 9.46875V10.7812C3.5625 11.1641 3.26172 11.4375 2.90625 11.4375H1.59375C1.21094 11.4375 0.9375 11.1641 0.9375 10.7812V9.46875C0.9375 9.11328 1.21094 8.8125 1.59375 8.8125Z"
            fill="#006589"
        />
    </svg>
);

export const close = () => (
    <svg
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect
            x="15.9162"
            y="2.30664"
            width="18.6409"
            height="2.57116"
            rx="1.28558"
            transform="rotate(135 15.9162 2.30664)"
            fill="#006589"
        />
        <rect
            x="14.2056"
            y="15.4863"
            width="18.6409"
            height="2.57116"
            rx="1.28558"
            transform="rotate(-135 14.2056 15.4863)"
            fill="#006589"
        />
    </svg>
);

export const search = () => (
    <svg
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M17.7188 16.8086L13.0078 12.0977C14.0273 10.8672 14.5898 9.28516 14.5898 7.5625C14.5898 3.55469 11.2852 0.25 7.27734 0.25C3.23438 0.25 0 3.55469 0 7.5625C0 11.6055 3.26953 14.875 7.27734 14.875C8.96484 14.875 10.5469 14.3125 11.8125 13.293L16.5234 18.0039C16.6992 18.1797 16.9102 18.25 17.1562 18.25C17.3672 18.25 17.5781 18.1797 17.7188 18.0039C18.0703 17.6875 18.0703 17.1602 17.7188 16.8086ZM1.6875 7.5625C1.6875 4.46875 4.18359 1.9375 7.3125 1.9375C10.4062 1.9375 12.9375 4.46875 12.9375 7.5625C12.9375 10.6914 10.4062 13.1875 7.3125 13.1875C4.18359 13.1875 1.6875 10.6914 1.6875 7.5625Z"
            fill="black"
        />
    </svg>
);

export const chevron = () => (
    <svg
        width="16"
        height="9"
        viewBox="0 0 16 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M7.28125 8.21875L1.28125 2.21875C0.875 1.84375 0.875 1.1875 1.28125 0.8125C1.65625 0.40625 2.3125 0.40625 2.6875 0.8125L8 6.09375L13.2812 0.8125C13.6562 0.40625 14.3125 0.40625 14.6875 0.8125C15.0938 1.1875 15.0938 1.84375 14.6875 2.21875L8.6875 8.21875C8.3125 8.625 7.65625 8.625 7.28125 8.21875Z"
            fill="black"
        />
    </svg>
);

export const burgundyorangeclose = () => (
    <svg
        width="12"
        height="13"
        viewBox="0 0 12 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M11.5974 10.855C11.9216 11.1885 11.9216 11.7295 11.5974 12.0629C11.2732 12.3964 10.7471 12.3964 10.4229 12.0629L6.33393 7.8263L2.21592 12.0615C1.8917 12.395 1.36567 12.395 1.04142 12.0615C0.717173 11.7281 0.717207 11.1871 1.04142 10.8536L5.16081 6.6198L1.04028 2.35255C0.716065 2.01911 0.716065 1.47811 1.04028 1.14463C1.3645 0.811148 1.89053 0.811184 2.21478 1.14463L6.33393 5.4133L10.4519 1.17808C10.7762 0.844638 11.3022 0.844638 11.6264 1.17808C11.9507 1.51152 11.9506 2.05253 11.6264 2.38601L7.50704 6.6198L11.5974 10.855Z"
            fill="url(#paint0_linear_17409_4108)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_17409_4108"
                x1="3.59533"
                y1="-3.78389"
                x2="17.4985"
                y2="-2.60436"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0.113451" stopColor="#710049" />
                <stop offset="1" stopColor="#E37222" />
            </linearGradient>
        </defs>
    </svg>
);


export const globe = () => (
    <svg width="54" height="50" viewBox="0 0 54 50" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.76924 20.16H18.4371C18.2085 20.541 18.1323 20.9982 18.1323 21.3792C18.1323 22.7508 19.1991 23.8175 20.5707 23.8175C21.9423 23.8175 23.0091 22.7508 23.0091 21.3792C23.0091 20.6934 22.7043 20.0838 22.1709 19.6266C24.8379 18.4836 26.6667 15.8928 26.6667 12.8448C26.6667 9.79687 24.7617 7.2061 22.0947 6.06311C23.5425 5.75831 25.0665 5.52971 26.6667 5.52971C37.4108 5.52971 46.1737 14.2926 46.1737 25.0367C46.1737 26.1797 46.0213 27.3227 45.8689 28.3895C44.8021 27.4751 43.4305 26.8655 41.9065 26.8655C41.1445 26.8655 40.3825 27.0179 39.6967 27.3227C38.1728 25.9511 36.1916 25.0367 33.9818 25.0367C30.0194 25.0367 26.7429 27.7037 25.7523 31.2851C22.0947 32.0471 19.3515 35.2474 19.3515 39.0574C19.3515 40.81 19.8849 42.4102 20.7993 43.7056C12.8746 41.191 7.15965 33.7996 7.15965 25.0367C7.15965 23.3603 7.31205 21.7602 7.76924 20.16ZM32.7626 18.9408C31.391 18.9408 30.3242 20.0838 30.3242 21.3792C30.3242 22.7508 31.391 23.8175 32.7626 23.8175C34.1342 23.8175 35.201 22.7508 35.201 21.3792C35.201 20.0838 34.1342 18.9408 32.7626 18.9408Z" fill="#710049" />
        <path d="M11.8697 5.86272C13.9271 5.86272 15.7559 7.23431 16.4417 9.13929C17.2037 8.60589 18.1181 8.3011 19.1849 8.3011C21.8518 8.3011 24.0616 10.5109 24.0616 13.1779C24.0616 15.921 21.8518 18.0546 19.1849 18.0546H6.99298C4.24981 18.0546 2.11623 15.921 2.11623 13.1779C2.11623 10.5109 4.24981 8.3011 6.99298 8.3011H7.60258C8.44077 6.85331 10.041 5.86272 11.8697 5.86272ZM33.8151 27.8081C36.0249 27.8081 37.9299 29.0273 38.9967 30.8561C39.6825 30.0941 40.6731 29.6369 41.7399 29.6369C43.721 29.6369 45.3974 31.3133 45.3974 33.2945C45.3974 33.5231 45.3212 33.7517 45.3212 33.9041H45.3974C48.3692 33.9041 50.8838 36.4186 50.8838 39.3904C50.8838 42.4384 48.3692 44.8768 45.3974 44.8768H27.1096C24.0616 44.8768 21.6232 42.4384 21.6232 39.3904C21.6232 36.4186 24.0616 33.9041 27.1096 33.9041H27.7192C27.7192 30.5513 30.3862 27.8081 33.8151 27.8081Z" fill="#EFE3EB" />
    </svg>
)
export const roundArrow = () => (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="30" height="30" rx="15" fill="white" />
        <path d="M22.6477 15.8034L16.9335 21.5177C16.5049 21.982 15.7549 21.982 15.3263 21.5177C14.862 21.0891 14.862 20.3391 15.3263 19.9106L19.0763 16.1249H8.14774C7.50488 16.1249 7.00488 15.6249 7.00488 14.982C7.00488 14.3749 7.50488 13.8391 8.14774 13.8391H19.0763L15.3263 10.0891C14.862 9.66057 14.862 8.91057 15.3263 8.482C15.7549 8.01772 16.5049 8.01772 16.9335 8.482L22.6477 14.1963C23.112 14.6249 23.112 15.3749 22.6477 15.8034Z" fill="#006589" />
    </svg>

)

export const chevronGradient = () => (
    <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1.93407 15.3654C1.64344 15.3654 1.38511 15.2685 1.19136 15.0747C0.771566 14.6872 0.771566 14.0091 1.19136 13.6216L6.64865 8.13203L1.19136 2.67474C0.771566 2.28724 0.771566 1.60911 1.19136 1.22161C1.57886 0.801823 2.25698 0.801823 2.64448 1.22161L8.84448 7.42161C9.26427 7.80911 9.26427 8.48724 8.84448 8.87474L2.64448 15.0747C2.45073 15.2685 2.1924 15.3654 1.93407 15.3654Z"
            fill="url(#paint0_linear_2134_6926)"/>
        <defs>
            <linearGradient id="paint0_linear_2134_6926" x1="1.52791" y1="-9.31612" x2="14.1471" y2="-8.72466"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.113451" stop-color="#710049"/>
                <stop offset="1" stop-color="#E37222"/>
            </linearGradient>
        </defs>
    </svg>

)
    
